module.exports = __webpack_public_path__ + "static/media/checkmark.d6441127.svg";